// extracted by mini-css-extract-plugin
export default {"root":"root___ZwGi6","icon360":"icon360___Ssddf"};